import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProgressSpinnerComponent} from './view/progress-spinner/progress-spinner.component';
import {ModalOverlayDirective} from './directives/modal-overlay.directive';
import {MiniProgressSpinnerComponent} from './view/mini-progress-spinner/mini-progress-spinner.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {InViewDirective} from './directives/in-view.directive';

@NgModule({
  declarations: [
    ProgressSpinnerComponent,
    MiniProgressSpinnerComponent,
    ModalOverlayDirective,
    InViewDirective
  ],
  imports: [
    CommonModule,
    MatProgressSpinnerModule
  ],
  exports: [
    ProgressSpinnerComponent,
    MiniProgressSpinnerComponent,
    ModalOverlayDirective,
    InViewDirective
  ]
})
export class MiscModule {
}
